import {
  useCompositeItem
} from "./54J7EHCU.js";
import {
  useToolbarContext
} from "./IPFII6JW.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "./CFEUKV6C.js";
import {
  __objRest,
  __spreadValues
} from "./PNRLI7OV.js";

// src/toolbar/toolbar-item.ts
var useToolbarItem = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useToolbarContext();
    store = store || context;
    props = useCompositeItem(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarItem = createMemoComponent((props) => {
  const htmlProps = useToolbarItem(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  ToolbarItem.displayName = "ToolbarItem";
}

export {
  useToolbarItem,
  ToolbarItem
};
